import { render } from "./invoices-discount.vue?vue&type=template&id=2e01caa0"
import script from "./invoices-discount.vue?vue&type=script&lang=js"
export * from "./invoices-discount.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__